import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import { Anchor } from "arv-extends";
import { FOOTER } from "npmlinks-constants";

const {
  FOOTER_LINKS: { EXCLUDED_TEXTS },
} = FOOTER;

@inject("CommonStore")
@observer
class FooterLinkItem extends Component {
  render() {
    const { data = [], level, CommonStore } = this.props;
    const { isDesktop } = CommonStore;

    return (
      <Fragment>
        {data.map((item, iterinder) => (
          <ul className="wc-footerlinks-ul">
            <li
              className={`${
                iterinder === data.length - 1 ? "is-last" : ""
              } wc-footerlinkslevel${level}-li wc-footerlinks-li`}
            >
              <Anchor.component
                className={`${
                  iterinder === data.length - 1 ? "is-last" : ""
                } wc-footerlinkslevel${level}-anchor wc-footerlinks-anchor`}
                to={item.url}
                href={item.url}
                target={isDesktop ? "_blank" : "_self"}
              >
                {!EXCLUDED_TEXTS.includes(item.label) && item.label}
              </Anchor.component>
            </li>
            <FooterLinkItem
              data={item.children || []}
              level={level + 1}
              length={data.length}
              CommonStore={CommonStore}
            />
          </ul>
        ))}
      </Fragment>
    );
  }
}

FooterLinkItem.wrappedComponent.propTypes = {
  data: PropTypes.shape({}).isRequired,
  level: PropTypes.bool.isRequired,
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
};

export default FooterLinkItem;
